import { render, staticRenderFns } from "./SvgChevronLeft.vue?vue&type=template&id=b0b4b104&"
import script from "./SvgChevronLeft.vue?vue&type=script&lang=js&"
export * from "./SvgChevronLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports